// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeliveryAddressModel from '../../model/delivery-address-model';
import DeliveryAddressDTO from '../dto/delivery-address-dto';
import dtoSchema from '../schemas/delivery-address-schema';
import ContactAddressModel from '../../model/contact-address-model';

export default abstract class DeliveryAddressModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeliveryAddressDTO>) {
    super();
    if (data) {
      this.customerNumber = data.customerNumber ?? undefined;
      this.contactId = data.contactId ?? undefined;
      this.parentContactId = data.parentContactId ?? undefined;
      this.contactAccountId = data.contactAccountId ?? undefined;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.address = data.address ? ContactAddressModel.toModel(data.address) : undefined;
      this.isDifferentFromOwner = data.isDifferentFromOwner;
    }
  }
  /**
  * @type {int32}
  */
  customerNumber?: number;
  /**
  * @type {uuid}
  */
  contactId?: string;
  /**
  * @type {uuid}
  */
  parentContactId?: string;
  /**
  * @type {uuid}
  */
  contactAccountId?: string;
  /**
  */
  languageIso2?: string;
  /**
  */
  address?: ContactAddressModel;
  /**
  */
  isDifferentFromOwner?: boolean;

  static toModel(dto: DeepPartial<DeliveryAddressDTO>): DeliveryAddressModel;
  static toModel(dto: DeepPartial<DeliveryAddressDTO> | undefined | null): DeliveryAddressModel | undefined;
  static toModel(dto: DeepPartial<DeliveryAddressDTO> | undefined | null): DeliveryAddressModel | undefined {
    return dto ? new DeliveryAddressModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeliveryAddressModel> | DeliveryAddressModel): DeliveryAddressDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      customerNumber: unwrapped.customerNumber,
      contactId: unwrapped.contactId,
      parentContactId: unwrapped.parentContactId,
      contactAccountId: unwrapped.contactAccountId,
      languageIso2: unwrapped.languageIso2,
      address: unwrapped.address,
      isDifferentFromOwner: unwrapped.isDifferentFromOwner,
    } as DeliveryAddressDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeliveryAddressModel, can not map to DeliveryAddressDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
